module.exports = __webpack_public_path__ + "static/hawaii-4-932f5f28ec2cf9eff30c32d2056c5206.png";